<div
	class="sidenav-content copo-datacenter-sidenav-content"
	@routeAnimation
>
	<div class="copo-datacenter-flex-box">

		<!-- Title -->
		<div class="copo-datacenter-title-block">
			<div class="copo-datacenter-title-label" translate>eoffer.offerLine.plural</div>
			<ng-container *ngIf="table" [ngTemplateOutlet]="resultLabel" [ngTemplateOutletContext]="{ offerLineCount:table.offerLineCount }"></ng-container>

			<ng-template #resultLabel let-offerLineCount="offerLineCount">
				<div *ngIf="offerLineCount !== undefined" class="copo-datacenter-result-label">
					<span>{{
						offerLineCount === 0
						? ('order-tracking.no.result' | translate)
						: offerLineCount > 1
						? ('datacenter.results' | translate:{value:offerLineCount})
						: ('datacenter.result' | translate)
					}}</span>
				</div>
			</ng-template>
		</div>

		<!-- Filters -->
		<div *ngIf="!isDraft && !searchMode" class="copo-filter-block">
			<div class="copo-label" translate>search.by</div>
			<div>
				<button
					type="button"
					mat-flat-button
					[color]="status === undefined ? 'primary' : undefined"
					[class.copo-button-selection-selected]="status === undefined"
					class="copo-button-selection copo-button-selection-margin"
					(click)="evtFilterStatusChanged()"
				>
					<span translate>filter.all</span>
				</button>
				<button
					type="button"
					mat-flat-button
					[color]="status === 'REQUESTED' ? 'primary' : undefined"
					[class.copo-button-selection-selected]="status === 'REQUESTED'"
					class="copo-button-selection copo-button-selection-margin"
					(click)="evtFilterStatusChanged('REQUESTED')"
				>
					<span translate>eoffer.status.requested</span>
				</button>
				<button
					type="button"
					mat-flat-button
					[color]="status === 'OFFERED' ? 'primary' : undefined"
					[class.copo-button-selection-selected]="status === 'OFFERED'"
					class="copo-button-selection copo-button-selection-margin"
					(click)="evtFilterStatusChanged('OFFERED')"
				>
					<span translate>eoffer.status.offered</span>
				</button>
				<button
					type="button"
					mat-flat-button
					[color]="status === 'OFFERED' ? 'primary' : undefined"
					[class.copo-button-selection-selected]="status === 'ACCEPTED'"
					class="copo-button-selection copo-button-selection-margin"
					(click)="evtFilterStatusChanged('ACCEPTED')"
				>
					<span translate>eoffer.status.accepted</span>
				</button>
			</div>
		</div>


		<!-- table -->
		<div class="copo-datacenter-grid-container">
			<copo-offer-lines-table #table [filterObs]="getFilterObs()" [type]="isDraft ? 'draftOnly' : 'noDraft'"></copo-offer-lines-table>
		</div>
	</div>
</div>